import AuthBootstrapper from 'components/AuthBootstrapper';
import { CookiesProvider } from 'react-cookie';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import { init } from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './store';
import DataLayer from 'pages/shared/DataLayer/DataLayer';
import FaviconInjector from 'pages/shared/FaviconInjector/FaviconInjector';

const isDevelopment = process.env.NODE_ENV === 'development';

init({
  dsn: process.env.REACT_APP_SENTRY_URL,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: isDevelopment ? 1.0 : 0.5,
  debug: isDevelopment,
  environment: process.env.NODE_ENV,
  autoSessionTracking: !isDevelopment,
});

ReactDOM.render(
  <Provider store={store}>
    <CookiesProvider>
      <Router>
        <AuthBootstrapper>
          <App />
          <DataLayer />
          <FaviconInjector />
        </AuthBootstrapper>
      </Router>
    </CookiesProvider>
  </Provider>,
  document.querySelector('#root'),
);

serviceWorker.unregister();
